import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getRouteIdentifierFromPath, getValidatedModelPath } from '@/routing';
import { selectModelType, switchModelType } from '@/store/slices/sessionSlice';
import { addError } from '@/store/slices/notificationsSlice';
import { useLocationChanged } from '@/routing/hooks';
import { logError } from '@/utils/logger';
export const useHandleModelTypeOnLocationChanged = () => {
    // NOTE: switchModelType still dispatches to Redux because modelType is not
    // part of the persisted-state contract being migrated.
    const dispatch = useAppDispatch();
    const modelTypeFromRedux = useAppSelector(selectModelType);
    const handleModelType = useCallback((location) => {
        try {
            const modelPath = getValidatedModelPath(location.pathname);
            if (modelPath) {
                const modelType = getRouteIdentifierFromPath(modelPath);
                if (modelType && modelType !== modelTypeFromRedux) {
                    dispatch(switchModelType(modelType));
                }
            }
            else if (modelTypeFromRedux != null) {
                dispatch(switchModelType(null));
            }
        }
        catch (error) {
            const errorMessage = 'UNKNOWN_ERROR';
            logError(errorMessage, error);
            dispatch(addError({ key: errorMessage }));
        }
    }, [dispatch, modelTypeFromRedux]);
    useLocationChanged(handleModelType);
};
